exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header[data-v-b618104c]{background-color:#d3d3d3}.header .logo-large[data-v-b618104c]{height:auto;max-height:300px;max-width:100%}.navbar[data-v-b618104c]{background-color:#008ba3!important;transition-timing-function:ease-in-out;transition-duration:.1s}.navbar .navbar-brand[data-v-b618104c]{margin-right:1.5rem}.navbar span[data-v-b618104c]{font-weight:700}@media (min-width:992px){.navbar[data-v-b618104c]{max-width:960px}}@media (min-width:1200px){.navbar[data-v-b618104c]{max-width:1140px}}.navbar.stuck[data-v-b618104c]{max-width:100%}@media (min-width:992px){.login-menu[data-v-b618104c]{min-width:600px}}@media (min-width:992px){#header-loggedin[data-v-b618104c]{padding-top:0;padding-bottom:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b618104c","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App/PageHeader.vue
// module id = 954
// module chunks = 24